import { Badge } from "@mantine/core";
import type { ChargeContract } from "../../apis/chargeContract";

const COLOR: Record<ChargeContract["status"], string> = {
  DRAFT     : "gray",
  ACTIVE    : "green",
  SUSPENDED : "orange",
  TERMINATED: "red",
  ARCHIVED  : "gray"
};

const LABEL: Record<ChargeContract["status"], string> = {
  DRAFT     : "Ноорог",
  ACTIVE    : "Идэвхтэй",
  SUSPENDED : "Түр зогссон",
  TERMINATED: "Цуцласан",
  ARCHIVED  : "Архивласан"
};

export function ContractStatusBadge({ status }: { status: ChargeContract["status"] }) {
  return <Badge color={COLOR[status]} variant="light">{LABEL[status]}</Badge>;
}
